import * as Icons from "lucide-react";

/**
 * Multi-format aspect-ratio export checkbox row.
 *
 * The reel always renders 16:9 as the master. These checkboxes add
 * background-rendered 9:16 (Reels/TikTok) and 1:1 (Feed) variants —
 * center-cropped from the master, no extra compute on Magnific.
 */
export default function AspectExportControls({
  extraAspects = [],
  setExtraAspects,
  className = "",
}) {
  const options = [
    {
      id: "9_16",
      label: "Reels & TikTok",
      sub: "9:16 vertical, smart-cropped",
      icon: "Smartphone",
    },
    {
      id: "1_1",
      label: "Square / Feed",
      sub: "1:1 for Instagram & Facebook feed",
      icon: "Square",
    },
  ];

  const toggle = (id) => {
    if (extraAspects.includes(id)) {
      setExtraAspects(extraAspects.filter((a) => a !== id));
    } else {
      setExtraAspects([...extraAspects, id]);
    }
  };

  return (
    <div className={`border border-white/5 bg-black/30 rounded-xl p-4 ${className}`}>
      <div className="flex items-center gap-2 mb-2">
        <Icons.Crop size={14} className="text-amber-400" />
        <span className="text-[13px] text-white font-medium">
          Also export for social
        </span>
        <span className="text-[9px] tracking-[0.2em] uppercase text-amber-500/70 ml-1 px-1.5 py-0.5 rounded border border-amber-500/30">
          New
        </span>
      </div>
      <p className="text-[11px] text-zinc-500 mb-3 leading-relaxed">
        Same finished reel, rendered into other aspect ratios. Center-cropped
        with the property kept in frame. Zero extra Magnific cost.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {options.map((o) => {
          const I = Icons[o.icon] || Icons.Crop;
          const on = extraAspects.includes(o.id);
          return (
            <label
              key={o.id}
              className={`flex items-start gap-3 p-3 rounded-lg border cursor-pointer transition-all ${
                on
                  ? "bg-amber-500/10 border-amber-500/50"
                  : "bg-black/40 border-white/5 hover:border-white/20"
              }`}
              data-testid={`aspect-toggle-${o.id}`}
            >
              <input
                type="checkbox"
                checked={on}
                onChange={() => toggle(o.id)}
                className="mt-1 accent-amber-500"
              />
              <div className="min-w-0">
                <div className="flex items-center gap-1.5">
                  <I size={12} className="text-amber-400/80" />
                  <span className="text-[12px] text-white font-medium">
                    {o.label}
                  </span>
                </div>
                <div className="text-[10px] text-zinc-500 mt-0.5">
                  {o.sub}
                </div>
              </div>
            </label>
          );
        })}
      </div>
    </div>
  );
}
